import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { spacing, color, breakpoint } }) => css`
    display: grid;
    grid-template-columns: 100%;
    grid-gap: ${spacing.km8};
    justify-items: start;
    padding: ${spacing.km4};
    background-color: ${color.background.neutral.weak};
    width: 100%;

    @media screen and (min-width: ${breakpoint.md.minWidth}) {
      grid-template-columns: repeat(12, 1fr);
      padding: ${spacing.km10};
    }

    > div {
      @media screen and (min-width: ${breakpoint.md.minWidth}) {
        grid-column: auto/span 6;
      }

      @media screen and (min-width: ${breakpoint.lg.minWidth}) {
        grid-column: auto/span 3;
      }
    }
  `}
`;
